import { choosePlatform } from '../../../helpers/utils';

interface IProps {
	style: string;
	color?: string;
}

export const Pro = ({
	style,
	color = choosePlatform() ? '#35168C' : '#DF1737',
}: IProps) => {
	return (
		<svg
			width="158"
			height="212"
			viewBox="0 0 158 212"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={style}
		>
			<path
				d="M0 8C0 3.58172 3.58172 0 8 0H150C154.418 0 158 3.58172 158 8V177.863C158 181.233 155.887 184.243 152.717 185.387L81.7165 211.019C79.961 211.653 78.039 211.653 76.2835 211.019L5.28349 185.387C2.11293 184.243 0 181.233 0 177.863V8Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M42.4078 66.5398C43.6584 64.4868 46.7241 64.4868 47.9692 66.5398L52.0254 73.1968C53.3646 75.3937 55.5725 76.9541 58.1181 77.5131L64.6921 78.9574L63.0209 81.7132C62.9655 81.8072 62.8991 81.9013 62.8327 81.9954C62.3568 82.6207 61.6596 83.0689 60.8683 83.2405L46.857 86.3338C39.7129 87.911 36.8686 96.4107 41.7217 101.818L43.9297 104.275C43.0775 104.385 42.2364 104.612 41.434 104.95L34.1351 108.01C31.8497 108.967 29.4204 107.18 29.6362 104.856L30.3722 97.1472C30.6156 94.5906 29.769 92.0561 28.037 90.136L22.7966 84.32C21.2084 82.5548 22.1049 79.7491 24.512 79.2179L32.2592 77.5135C34.8103 76.9546 37.0127 75.3941 38.3519 73.1972L42.4078 66.5398ZM55.7993 108.153L55.9266 108.292C57.6808 110.245 58.5386 112.818 58.2895 115.413L56.967 129.408C56.7346 131.871 59.2856 133.719 61.6541 132.723L74.8464 127.167C77.2868 126.143 80.0426 126.143 82.4829 127.167L95.6752 132.723C98.0437 133.719 100.595 131.871 100.362 129.408L99.0397 115.413C98.7907 112.818 99.6485 110.245 101.403 108.292L110.882 97.7278C112.553 95.8685 111.596 92.9191 109.095 92.3656L95.0777 89.2722C92.8144 88.7742 90.8223 87.4959 89.4499 85.6865C89.2507 85.4264 89.0681 85.1552 88.8965 84.8785L81.5588 72.793C80.2584 70.646 77.0709 70.646 75.7706 72.793L71.9579 79.0682V79.0738L68.4329 84.8787C67.0716 87.1143 64.8359 88.7025 62.2517 89.2725L48.2349 92.3659C45.7337 92.9192 44.7763 95.8688 46.4475 97.7281L55.7995 108.148L55.7993 108.153ZM113.399 104.274C114.252 104.385 115.093 104.612 115.895 104.949L123.194 108.009C125.479 108.967 127.909 107.179 127.693 104.855L126.957 97.1467C126.713 94.5901 127.56 92.0556 129.292 90.1355L134.533 84.3196C136.121 82.5543 135.224 79.7487 132.817 79.2174L125.07 77.5131C122.519 76.9542 120.316 75.3937 118.977 73.1968L114.921 66.5397C113.67 64.4868 110.605 64.4868 109.36 66.5397L105.303 73.1968C103.964 75.3937 101.756 76.9541 99.2107 77.5131L92.6367 78.9573L94.3079 81.7131C94.7451 82.438 95.4589 82.9748 96.2889 83.2017C96.3443 83.2183 96.4052 83.2294 96.4605 83.2404L110.472 86.3338C117.616 87.9109 120.46 96.4107 115.607 101.818L113.399 104.274Z"
				fill="white"
			/>
		</svg>
	);
};
